module.exports = __webpack_public_path__ + "img/Market Explorer_old.6ae483df.svg";